module.exports = "//d274d294w9cx2v.cloudfront.net/97a3323b564e036a2e5e6462cd86792ccec15c00/images/cashRegistryDefaultSmall.webp";